import { LitElement, html } from 'lit';
import { customElement, query } from 'lit/decorators.js';

import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import { LayoutList } from './types';
import layoutIcon from '@amityeko/design-system/dist/assets/icons/layout';

import '@amityeko/design-system/dist/elements/dialog';
import '@amityeko/design-system/dist/elements/inline-message';
import '@amityeko/design-system/dist/elements/icon';

import type AmityekoDialog from '@amityeko/design-system/dist/elements/dialog';

import styles from './styles';

/**
 * @dependency amityeko-dialog
 * @dependency amityeko-inline-message
 * @dependency amityeko-icon
 *
 *
 */
@customElement('rnr-image-layout-list')
export default class RnRImageLayoutList extends LitElement {
  static styles = styles;

  @query('#dialog') dialog!: AmityekoDialog;

  show() {
    this.dialog.show();
  }

  private _onClick() {
    this.dialog.show();
  }

  private _handleSelect(layout: LayoutList) {
    const selectedLayout = layout;
    emit(this, 'rnr-select-layout', { detail: { layout: selectedLayout } });
    this.dialog.hide();
  }

  private _onDialogBack() {
    this.dialog.hide();
    emit(this, 'rnr-image-layout-list-back');
  }

  protected render() {
    return html`
      <slot @click=${this._onClick}></slot>

      <amityeko-dialog
        id="dialog"
        label="Choose Layout"
        ?hasBackButton=${true}
        @amityeko-back=${this._onDialogBack}
      >
        <div class="content">
          <amityeko-inline-message .variant=${'info'} ?hasCustomIcon=${true}>
            <amityeko-icon .iconSize=${'20px'} slot="custom-icon">${layoutIcon}</amityeko-icon>
            Choose layout for your images.
          </amityeko-inline-message>

          <!-- Layout SQUARE -->
          <div class="layout layout--square" @click=${() => this._handleSelect(LayoutList.SQUARE)}>
            <div class="layout__content">
              <div class="layout__box"></div>
            </div>
          </div>

          <!-- Layout CIRCLE -->
          <div class="layout layout--circle" @click=${() => this._handleSelect(LayoutList.CIRCLE)}>
            <div class="layout__content">
              <div class="layout__box"></div>
            </div>
          </div>

          <!-- Layout SQUARE-3H -->
          <div
            class="layout layout--square-3h"
            @click=${() => this._handleSelect(LayoutList.SQUARE3H)}
          >
            <div class="layout__content">
              <div class="layout__box"></div>
              <div class="layout__box"></div>
              <div class="layout__box"></div>
            </div>
          </div>

          <!-- Layout SQUARE-1H2S -->
          <div
            class="layout layout--square-1h2s"
            @click=${() => this._handleSelect(LayoutList.SQUARE1H2S)}
          >
            <div class="layout__content">
              <div class="layout__box layout__box--one"></div>
              <div class="layout__box layout__box--two"></div>
              <div class="layout__box layout__box--three"></div>
            </div>
          </div>

          <!-- Layout SQUARE-4S -->
          <div
            class="layout layout--square-4s"
            @click=${() => this._handleSelect(LayoutList.SQUARE4S)}
          >
            <div class="layout__content">
              <div class="layout__box"></div>
              <div class="layout__box"></div>
              <div class="layout__box"></div>
              <div class="layout__box"></div>
            </div>
          </div>

          <!-- Layout SQUARE-1v3s -->
          <div
            class="layout layout--square-1v3s"
            @click=${() => this._handleSelect(LayoutList.SQUARE1V3S)}
          >
            <div class="layout__content">
              <div class="layout__box layout__box--one"></div>
              <div class="layout__box layout__box--two"></div>
              <div class="layout__box layout__box--three"></div>
              <div class="layout__box layout__box--four"></div>
            </div>
          </div>
        </div>
      </amityeko-dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rnr-image-layout-list': RnRImageLayoutList;
  }
}
